import BooksContainer from './BooksContainer';

export default { BooksContainer };
